module.exports = __webpack_public_path__ + "static/cstoreslider-11-min-75f9cac60751747c42e5b8a2ba7e7066.jpg";